module.exports = __webpack_public_path__ + "img/main_video_main.e0b2add9.png";